module.exports = __webpack_public_path__ + "925a45d2.svg";